import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from 'atoms';
import { ProductBrand, color, tracking } from 'designs';

type BrandPillProps = {
  logoSrc: string;
  label: string;
  brand: ProductBrand;
  to: string;
};

const BrandPill: React.FC<BrandPillProps> = ({
  logoSrc,
  label,
  brand,
  to,
}) => {
  return (
    <Link className="pill-card" to={to}>
      <div className={`pill-logo-shell pill-logo-shell--${brand}`}>
        <img src={logoSrc} alt="" className="pill-logo" />
      </div>
      <Text color={color.white} tracking={tracking.wide} transform="uppercase">
        {label}
      </Text>
    </Link>
  );
};

export default BrandPill;
